@if(loading()) {
  <div class="m-3">
    <mat-spinner></mat-spinner>
  </div>
} @else if(error()) {
  <p>{{ "error_page.general_error_message" | transloco }}</p>
} @else if(groups()) {
  <mat-tree
    [dataSource]="dataSource"
    [treeControl]="treeControl"
    class="ml-3 groups-tree mb-3"
    style="background: unset">
    <!-- This is the tree node template for leaf nodes -->
    <!-- There is inline padding applied to this node using styles.
    This padding value depends on the mat-icon-button width. -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <div class="mat-tree-node row">
        <ng-template
        *ngTemplateOutlet="
          treeNode;
          context: { node: node, root: groups()[0] }
        "></ng-template>
        <ng-template
        *ngTemplateOutlet="
          editGroupsControls;
          context: { node: node, root: groups()[0] }
        "></ng-template>
      </div>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <div class="mat-tree-node row">
        <ng-container
        *ngTemplateOutlet="
          treeNode;
          context: { node: node, root: groups()[0] }
        "></ng-container>
        <div class="align-self-baseline">
          <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
            </mat-icon>
          </button>
        </div>
        <ng-template
        *ngTemplateOutlet="
          editGroupsControls;
          context: { node: node, root: groups() }
        "></ng-template>
      </div>
      <!-- There is inline padding applied to this div using styles.
      This padding value depends on the mat-icon-button width.  -->
      <div
        [class.groups-tree-invisible]="!treeControl.isExpanded(node)"
        role="group"
        matTreeNodePadding="0.5"
        style="cursor: pointer">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
}

<ng-template #editGroupsControls let-node="node" let-root="root">
  <ng-container *lorenShowForPrivileges="[privileges.WRITE_GROUPS]">
    @if (editable && node.isRoot) {
      <div class="group-edit-controls">
        <button color="accent" mat-icon-button (click)="addHierarchyItem(node)">
          <mat-icon class="mat-icon-rtl-mirror"> add </mat-icon>
        </button>
      </div>
    }
    @if (editable && !node.isRoot) {
      <div class="group-edit-controls">
        @if (!node.isAsset) {
          <button
            color="accent"
            mat-icon-button
            (click)="addHierarchyItem(node)">
            <mat-icon class="mat-icon-rtl-mirror"> edit </mat-icon>
          </button>
        }
        @if (node.isAsset && root.id !== node.parentGroupId) {
          <button
            color="warn"
            mat-icon-button
            (click)="removeHierarchyItem(node)">
            <mat-icon class="mat-icon-rtl-mirror"> close </mat-icon>
          </button>
        }
        @if (!node.isAsset) {
          <button
            color="warn"
            mat-icon-button
            (click)="removeHierarchyItem(node)">
            <mat-icon class="mat-icon-rtl-mirror"> delete </mat-icon>
          </button>
        }
      </div>
    }
  </ng-container>
</ng-template>

<ng-template #treeNode let-node="node" let-root="root">
  <div class="text-center pr-2">
    @if (node.isAsset) {
      <img
        [src]="assetsMap.get(node.id).image | lorenImage | async"
        alt="Asset image"
        width="25"
        class="" />
    }
    @if (!node.isAsset && !showCheckboxes) {
      <mat-icon class="pr-2"
        >sell</mat-icon
        >
      }
    </div>
    @if (!showCheckboxes) {
      <div>
        <ng-template
      *ngTemplateOutlet="
        treeNodeOnlyLabels;
        context: { node: node, root: root }
      "></ng-template>
      </div>
    }
    @if (showCheckboxes) {
      @if (node.id === root.id) {
        <ng-template
        *ngTemplateOutlet="
          treeNodeOnlyLabels;
          context: { node: node, root: root }
        "></ng-template>
      }
      @if (node.id !== root.id) {
        <mat-checkbox
          (ngModelChange)="handleGroupSelection(node)"
          [(ngModel)]="node.isChecked"
          color="accent">
          {{ node.name }}
          @if (node.description) {
            <div class="text-black-50">
              {{ node.description }}
            </div>
          }
          @if (!node.description) {
            <div class="text-black-50">
              {{ "group.no_description" | transloco }}
            </div>
          }
          <ng-content></ng-content>
        </mat-checkbox>
      }
    }
  </ng-template>

  <ng-template #treeNodeOnlyLabels let-node="node" let-root="root">
    <h4 class="m-0 p-0">
      {{ node.name !== rootName ? node.name : ("group.all_groups" | transloco) }}
    </h4>
    @if (node.id !== root.id) {
      @if (node.description) {
        <div class="text-black-50">
          {{ node.description }}
        </div>
      }
      @if (!node.description) {
        <div class="text-black-50">
          {{ "group.no_description" | transloco }}
        </div>
      }
    }
    <ng-content></ng-content>
  </ng-template>

  @if (assetsWithoutGroup && showAssetsWithoutGroup) {
    <mat-divider></mat-divider>
    <mat-list role="list">
      <div mat-subheader>{{ "group.assets_without_group" | transloco }}</div>
      @for (asset of assetsWithoutGroup; track asset) {
        <mat-list-item role="listitem">
          <img
            [src]="assetsMap.get(asset.id).image | lorenImage | async"
            width="25"
            alt="Asset image"
            class="" />
          <span class="ml-2">{{ asset.name }}</span>
        </mat-list-item>
      }
    </mat-list>
  }
